import {useContext} from 'react';

import ModalContext from 'src/context/ModalContext';

export default function useModal() {
  const {showModal, hideModal} = useContext(ModalContext);

  return {showModal, hideModal};
}
